import { render } from "./Styleguide-Layout-Tabs-Tab.vue?vue&type=template&id=5cf60345"
import script from "./Styleguide-Layout-Tabs-Tab.vue?vue&type=script&lang=js"
export * from "./Styleguide-Layout-Tabs-Tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__